import { styled } from '@innowise-group/mui-kit';
import { Image as BaseImage } from '@shared-mui-components';

export const Input = styled.input`
  display: none;
`;

export const Image = styled(BaseImage)``;

export const Avatar = styled.div`
  & > img {
    object-fit: cover;
    border-radius: 50%;
    pointer-events: none;
    width: 9.375rem;
    height: 9.375rem;
  }
  cursor: pointer;
  width: 9.375rem;
  flex-shrink: 0;
  height: 9.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AvatarContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NoImageContainer = styled.div`
  width: 9.375rem;
  height: 9.375rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.general.lightGrey[50]};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: ${({ theme }) => theme.animation.transition};
  &:hover {
    background-color: ${({ theme }) => theme.palette.general.lightGrey[40]};
  }
`;

export const AvatarFieldError = styled.div`
  color: ${({ theme }) => theme.palette.state.error.default};
  position: absolute;
  ${({ theme }) => theme.fonts.primary[10]}
  min-height: 17px;
  bottom: -20px;
`;
